import { BorderButton, TintButton } from 'components/common/Button';
import { PopupButtons } from 'components/common/Popup/PopupButtons';
import { Lang } from 'constants/Lang';
import styles from './subsPopup.module.css';

type Props = {
    onConfirm?: () => void
    onCancel?: () => void
}

export const SubsPopup: React.FC<Props> = ({onConfirm, onCancel}) => (
    <div className={styles.root}>
        <p>{Lang.ja.subsDescription}</p>
        <PopupButtons>
            <BorderButton className={styles.button} onClick={onCancel}>
                {Lang.ja.cancel}
            </BorderButton>
            <TintButton className={styles.button} onClick={onConfirm}>
                {Lang.ja.ok}
            </TintButton>
        </PopupButtons>
    </div>
)
